<template>
  <div class="col-12">
    <hr />
    <EditorGroupToggle
      label="Financials"
      target="toggleGroupFinancials"
      class="mb-4"
      :collapsed="false"
    />
    <div id="toggleGroupFinancials" class="collapse show row">
      <div class="col-3 mb-3">
        <Field
          type="text"
          name="price"
          :label="`${labelPrefix} Standard Price`"
          :value="managersOnly ? '0.00' : price"
          :readonly="managersOnly"
        />
      </div>
      <div class="col-3 mb-3">
        <Field
          type="text"
          name="fad_price"
          :label="`${labelPrefix} FAD/Elite Price`"
          :value="managersOnly ? '0.00' : fadPrice"
          :readonly="managersOnly"
        />
      </div>
      <div class="col-3 mb-3" v-if="!dealerOnly">
        <Field
          type="text"
          name="distributor_price"
          label="Distributor/Factory Employee Price"
          :value="distributorPrice"
        />
      </div>
      <div class="col-3 mb-3">
        <Field
          v-if="isNateCourse"
          type="text"
          name="nate_price"
          label="NATE Price"
          :value="natePrice"
        />
      </div>
      <div class="col-3 mb-3" v-if="dealerOnly"></div>
        <div class="col-3 mb-3">
            <Field
                type="text"
                name="distributor_billing_amount"
                label="Distributor Billing Amount"
                :value="distributorBillingAmount"
            />
        </div>
        <div class="col-3 mb-3">
            <Field
                type="datepicker"
                name="distributor_billing_date"
                label="Distributor Billing Date"
                :value="distributorBillingDate"
            />
        </div>
      <div class="col-3 mb-3">
        <Field
          type="text"
          name="est_materials_fee"
          label="Estimated License/Materials Fee"
          :value="estMaterialsFee"
        />
      </div>
      <div class="col-3 mb-3">
        <Field
          type="text"
          name="act_materials_fee"
          label="Actual License/Materials Fee"
          :value="event.act_materials_fee"
        />
      </div>
      <div class="col-3 mb-3">
        <Field
          type="text"
          name="est_trainer_course_fee"
          label="Estimated Trainer Course Fee"
          :value="estTrainerCourseFee"
        />
      </div>
      <div class="col-3 mb-3">
        <Field
          type="text"
          name="act_trainer_course_fee"
          label="Actual Trainer Course Fee"
          :value="event.act_trainer_course_fee"
        />
      </div>
      <div class="col-12 mb-3">
        <Field
          type="checkbox"
          name="trainer_travel_reimbursed"
          id="cb_trainer_travel_reimbursed"
          label="Trainer travel fees are reimbursed for this event"
          :checkbox-value="1"
          v-model="trainerTravelReimbursed"
        />
      </div>
      <template v-if="trainerTravelReimbursed">
        <div class="col-3 mb-3">
          <Field
            type="text"
            name="est_trainer_travel_fee"
            label="Estimated Trainer Travel Fee"
            :value="estTrainerTravelFee"
          />
        </div>
        <div class="col-3 mb-3">
          <Field
            type="text"
            name="act_trainer_travel_fee"
            label="Actual Trainer Travel Fee"
            :value="event.act_trainer_travel_fee"
          />
        </div>
        <div class="col-6"></div>
      </template>
      <div class="col-3 mb-3">
        <Field
          type="datepicker"
          name="trainer_invoice_date"
          label="Trainer Invoice Date"
          :value="event.trainer_invoice_date"
        />
      </div>
      <div class="col-9"></div>
      <div class="col-12 mb-3">
        <Field
          type="checkbox"
          name="distributor_billed"
          id="cb_distributor_billed"
          label="Enable Distributor Flat Fee for this event (i.e. billing reports will only reflect distributor event flat fees)"
          :checkbox-value="1"
          v-model="distributorBilled"
        />
      </div>
      <template v-if="distributorBilled">
        <div class="col-3 mb-3">
          <Field
            type="text"
            name="distributor_billing_fee"
            label="Distributor Billing Flat Fee"
            :value="distributorBillingFee"
          />
        </div>
        <div class="col-9 mb-3">
          <Field
            type="text"
            name="distributor_billing_reason"
            label="Reason"
            :value="event.distributor_billing_reason"
          />
        </div>
      </template>
      <template v-else>
        <div class="col-12 mb-3">
          <Field
            type="checkbox"
            name="bill_before_event"
            id="cb_bill_before_event"
            label="Bill 50% of the minimum attendees when this event is created"
            :checkbox-value="1"
            v-model="billBeforeEvent"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    event: { type: Object, required: true },
    course: { type: Object, default: () => {} },
    managersOnly: { type: Boolean, default: false },
    dealerOnly: { type: Boolean, default: false },
  },

  data() {
    return {
      price: 0,
      fadPrice: 0,
      distributorPrice: 0,
      natePrice: 0,
      estMaterialsFee: null,
      estTrainerCourseFee: null,
      estTrainerTravelFee: null,
      trainerTravelReimbursed: false,
      distributorBilled: false,
      distributorBillingFee: null,
      distributorBillingAmount: null,
      distributorBillingDate: null,
      distributorBillingReason: null,
      billBeforeEvent: false,
    };
  },

  computed: {
    isDistributorOwned() {
      return (
        !!this.course &&
        this.course.owner_type == this.$root.constants.DISTRIBUTOR_OWNED
      );
    },
    isNateCourse() {
      return !!this.course && !!this.course.is_nate;
    },
    labelPrefix() {
      return this.isDistributorOwned
          ? this.dealerOnly
              ? ""
              : "Distributor "
          : "Factory ";
    },
  },

  watch: {
    course(val) {
      if (this.course && this.course.id !== this.event.course_id) {
        this.price = this.course.cost;
        this.fadPrice = this.course.fad_cost;
        this.distributorPrice = this.course.distributor_cost;
        this.natePrice = this.course.nate_cost;
        this.estMaterialsFee = this.course.materials_fee;
        this.estTrainerCourseFee = this.course.trainer_fee;
        this.trainerTravelReimbursed = !!this.course.trainer_travel_reimbursed;
        this.estTrainerTravelFee = this.course.trainer_travel_fee;
        this.distributorBilled = !!this.course.distributor_billed;
        this.distributorBillingFee = this.course.distributor_billing_fee;
        this.billBeforeEvent = !!this.course.bill_before_event;

        if (this.distributorBilled && !this.distributorBillingReason) {
          this.distributorBillingReason =
            "Distributor will handle billing for this course";
        }
      }
    },
  },

  created() {
    this.price = this.event.price || 0;
    this.fadPrice = this.event.fad_price || 0;
    this.distributorPrice = this.event.distributor_price || 0;
    this.natePrice = this.event.nate_price || 0;
    this.estMaterialsFee = this.event.est_materials_fee || null;
    this.estTrainerCourseFee = this.event.est_trainer_course_fee || null;
    this.trainerTravelReimbursed = !!this.event.trainer_travel_reimbursed;
    this.estTrainerTravelFee = this.event.est_trainer_travel_fee || null;
    this.distributorBilled = !!this.event.distributor_billed;
    this.distributorBillingFee = this.event.distributor_billing_fee || null;
    this.distributorBillingAmount = this.event.distributor_billing_amount || null;
    this.distributorBillingDate = this.event.distributor_billing_date || null;
    this.billBeforeEvent = !!this.event.bill_before_event;
  },
};
</script>